import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import {schoolJobsurl} from '../../../apis/urls'
import { jobscategorycreate } from '../../../apis/urls'
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";


const ViewJob = () => {

    useEffect(() => {
        JobListing();
    },[]
    );


    const { id,jobid } = useParams();
    const[ result,setResult ] = useState('');
    const[ jobCat,setJobcat ] = useState('');

    let navigate = useNavigate();


    const JobListing = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: schoolJobsurl+'/'+id+'/'+jobid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            //console.log(res.data.data)
            setResult(res.data.data);
            JobCategory(res.data.data.job_category_id);
          });

    }

    const JobCategory = (jid)=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: jobscategorycreate+'/'+jid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            
            //console.log('jobcat',res.data.data.name)
            setJobcat(res.data.data.name);
          });

    }

    const DeleteJob = (jobid) => {

        let r = window.confirm("Are you sure you want to delete this Job?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: schoolJobsurl+'/'+id+'/'+jobid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                navigate("/jobs/"+id)
            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }

const desc = decode(result.description);
 const decrypted_desc = ReactHtmlParser(desc)


    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Job</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/jobs/"+id}>Job</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Job View({result.title})</li>
                        </ol>
                    </nav>

                    <div className="jumbotron description-view">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Title</label>
                                    <div>{result.title}</div>
                                </div>
                                <div class="col-md-6">
                                    <label className="jobview-label">Description</label><br />
                                    {/* <ReactReadMoreReadLess
                                        charLimit={60}
                                        style={{color:'red'}}
                                        readMoreText={"Read more"}
                                        readLessText={"Read less"}
                                        readMoreClassName="read-more-less--more"
                                        readLessClassName="read-more-less--less"
                                        className="readmore">
                                       {decrypted_desc}
                                    </ReactReadMoreReadLess>  */}
                                   <span className="description-text">
                                   {/* <input type="text" value={{decrypted_desc}} maxLength={1} /> */}
                                   {/* {ReactHtmlParser(desc)} */}
                                   {decrypted_desc}

                                    </span>
                                        <Link className="description-texts" to={"/jobview/"+id+"/"+result.id+"/description_view"}>Read More</Link>


                                    {/* </div> */}
                                </div>

                                <div class="col-md-3">
                                    <label>Expires On</label>
                                    <div>{moment(result.expires_on).format('LL')}</div>
                                </div>
                            
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Contact Name</label>
                                    <div>{result.contact_name}</div>
                                </div>
                                <div class="col-md-6 ">
                                    <label className="jobview-label">Contact Email</label>
                                    <div onClick={() => window.location = 'mailto:'+result.contact_email}>{result.contact_email}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Job Category</label>
                                    <div>{jobCat}</div>
                                </div>

                            </div>
                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
									<Link to={"/edit_jobs/"+id+"/"+jobid} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
									<button onClick={() =>  { DeleteJob(jobid) } } style={{background:"#fff"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
									</div>
								</div>
                                
                            
                        </div>

                    </div>
                    


                </div>
            </aside>

        </div>
    )
}

export default ViewJob;